import { render, staticRenderFns } from "./VFormAvatarInput.vue?vue&type=template&id=126f772e&scoped=true&"
import script from "./VFormAvatarInput.vue?vue&type=script&lang=js&"
export * from "./VFormAvatarInput.vue?vue&type=script&lang=js&"
import style0 from "./VFormAvatarInput.vue?vue&type=style&index=0&id=126f772e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126f772e",
  null
  
)

export default component.exports